module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-button"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Button")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("按钮功能")]), _vm._v(" "), _c('div', {
    staticClass: "zan-button-group"
  }, [_c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', [_vm._v("default")])], 1), _vm._v(" "), _c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("primary")])], 1), _vm._v(" "), _c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("danger")])], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("禁用状态")]), _vm._v(" "), _c('div', {
    staticClass: "zan-button-group"
  }, [_c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("diabled")])], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("按钮尺寸")]), _vm._v(" "), _c('div', {
    staticClass: "zan-button-group"
  }, [_c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    attrs: {
      "size": "large"
    }
  }, [_vm._v("large")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "zan-button-group"
  }, [_c('div', {
    staticClass: "zan-button-3"
  }, [_c('zan-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("normal")])], 1), _vm._v(" "), _c('div', {
    staticClass: "zan-button-3"
  }, [_c('zan-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("small")])], 1), _vm._v(" "), _c('div', {
    staticClass: "zan-button-3"
  }, [_c('zan-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("mini")])], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("自定义按钮标签")]), _vm._v(" "), _c('div', {
    staticClass: "zan-button-group"
  }, [_c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    attrs: {
      "tag": "a",
      "type": "primary",
      "href": "https://www.youzan.com",
      "target": "_blank"
    }
  }, [_vm._v("a标签按钮")])], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("button group")]), _vm._v(" "), _c('div', {
    staticClass: "zan-button-group"
  }, [_c('zan-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("确认付款")]), _vm._v(" "), _c('zan-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("确认收货")]), _vm._v(" "), _c('zan-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("取消订单")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-83ccb626!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/button.vue
// module id = 255
// module chunks = 0